export const PRODUCTS_PRICES_QUERY = `#graphql
query ProductsByVariantGIDs($variantIds: [ID!]!) {
  nodes(ids: $variantIds) {
    ... on ProductVariant {
      id
      product {
        id
      }
      price {
        amount
        currencyCode

      }
      quantityAvailable
    }
  }
}`;
